import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { useStore } from "../../../../../../../hooks";
import { observer } from "mobx-react";
import {
  RetryContainer,
  RetryHeader,
  AddButtonWrapper,
  GeneratingRetryOverlay,
} from "./RetryComponent.styled";
import CircularProgress from '@mui/material/CircularProgress';
import RetryRow from "./RetryRow";
import Spinner from "../../../../../../../components/common/Spinner";
import RetryEditor from "./RetryEditor";

const RetryComponent = observer(() => {
  const { marketingStore } = useStore();
  const { retryStore } = marketingStore;
  
  if (!marketingStore.currentCampaign) {
    return <Spinner />;
  }
  
  return (
    <RetryContainer>
      {retryStore.retriesArray.map((retry, index) => (
        <div key={index}>
          <RetryHeader>{`Retry ${index + 1}`}</RetryHeader>
          <RetryRow index={retry} />
          <RetryEditor index={retry} />
        </div>
      ))}

      <AddButtonWrapper>
        <button 
          onClick={() => retryStore.add()} 
          disabled={retryStore.isMaxRetries}>
          <AddIcon />
          New
        </button>
      </AddButtonWrapper>

      {retryStore.isLoading && (
        <GeneratingRetryOverlay>
          <CircularProgress />
        </GeneratingRetryOverlay>
      )}
    </RetryContainer>
  );
});

export default RetryComponent;
